import React, { useEffect, useState } from "react";
import { getData, postData } from '../middleware/apiMiddleware';
import s from './QuestionExplanation.module.css';
import { useNavigate } from "react-router-dom";
import { RedButton, GreenButton, BlueButton } from './MyButton';
import { modifiedDate } from '../middleware/dateControl';

import MyTooltip from '../components/Utilities/MyTooltip';
import { SoundPlayer } from './Utilities/SoundPlayer.js';

import MyComponentLoading from '../components/Utilities/MyComponentLoading';

const InputTextArea = ({ value, setValue, updateValue, isLoading }) => {
  return (
    <div>
      <textarea className={s.customTextarea} value={value || ""} onChange={(e) => {
        setValue(e.target.value);
      }} />
      <div style={{ marginLeft: "auto" }}>
        <GreenButton isEnabled={!isLoading} clickedAction={() => { updateValue(value) }} bText={"Update"} />
      </div>
    </div>
  )
}

const AudioPlayer = ({ regenScriptAudio, script, audio, itemId, questionId, lang, isLoading }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", background: "white", padding: "0 0 0 10px", margin: "5px 0 0 0", borderTop: "2px solid #697568" }}>
      <GreenButton isEnabled={!isLoading} clickedAction={() => { regenScriptAudio(itemId, questionId, lang, script) }} bText={`Generate ${lang} Audio`} />
      {
        (audio) &&
        (<div style={{ width: "50px", height: "50px", marginLeft: "auto", display: "flex", alignItems: "center" }}>
          <SoundPlayer soundFile={audio} />
        </div>)
      }
    </div>
  )
}

// 解释类型定义
const explanationTypes = [
  { value: 'open', display: 'Open' },
  { value: 'figurative', display: 'Figurative' },
  { value: 'vocab', display: 'Vocab' },
  { value: 'mc', display: 'MC' },
  { value: 'tf', display: 'True False' }
];

export default function QuestionExplanation(prop) {
  const navigate = useNavigate();

  let questionId = prop.questionId;
  let itemId = prop.itemId;
  let createOrUpdateQtn = prop.createOrUpdateQtn;
  let triggerGenExplanationAll = prop.triggerGenExplanationAll;
  let triggerGenExplanationIncompleted = prop.triggerGenExplanationIncompleted;

  
  useEffect(() => {
    if (triggerGenExplanationAll) {
      generateScriptAi()
    }
  }, [triggerGenExplanationAll]);

  useEffect(() => {
    if (triggerGenExplanationIncompleted) {
      if (!audioZhSimplified) {
        generateScriptAi()
      }
    }
  }, [triggerGenExplanationIncompleted]);

  const [fetchCompleted, setFetchCompleted] = useState(false);
  const [explanationType, setExplanationType] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingEn, setIsLoadingEn] = useState(false);
  const [isLoadingZh, setIsLoadingZh] = useState(false);
  const [isLoadingZhSimplified, setIsLoadingZhSimplified] = useState(false);
  const [isUpdatingType, setIsUpdatingType] = useState(false);

  const [toggle, setToggle] = useState('en');
  const [targetToggle, setTargetToggle] = useState('Script');

  const [srtEn, setSrtEn] = useState(null);
  const [srtZh, setSrtZh] = useState(null);
  const [srtZhSimplified, setSrtZhSimplified] = useState(null);

  const [scriptEn, setScriptEn] = useState(null);
  const [scriptZh, setScriptZh] = useState(null);
  const [scriptZhSimplified, setScriptZhSimplified] = useState(null);

  const [audioEn, setAudioEn] = useState(null);
  const [audioZh, setAudioZh] = useState(null);
  const [audioZhSimplified, setAudioZhSimplified] = useState(null);

  // 新数据字段状态
  const [criteriaToModify, setCriteriaToModify] = useState('');
  const [refinedVersion, setRefinedVersion] = useState('');
  const [otherIssuesFound, setOtherIssuesFound] = useState('');
  const [displayData, setDisplayData] = useState('');
  const [activeButton, setActiveButton] = useState('');

  // 检查数据是否有效（非空且非默认提示）
  const isDataAvailable = (data) => {
    if (!data) return false;
    const trimmed = data.trim();
    return trimmed !== '' && trimmed !== 'No data available';
  };

  const fetchData = async () => {
    getData('questionApi/getQuestionExplanationById?id=' + questionId, navigate)
      .then(res => {
        let data = res.data;
        if (data) {
          setSrtEn(data.srtEn);
          setSrtZh(data.srtZh);
          setSrtZhSimplified(data.srtZhSimplified);

          setScriptEn(data.scriptEn);
          setScriptZh(data.scriptZh);
          setScriptZhSimplified(data.scriptZhSimplified);

          setAudioEn(data.audioEn);
          setAudioZh(data.audioZh);
          setAudioZhSimplified(data.audioZhSimplified);

          if (data.explanationType) {
            setExplanationType(data.explanationType);
          }

          // 处理新数据字段
          if (data.log) {
            setCriteriaToModify(data.log.criteria_to_modify || '');
            setRefinedVersion(data.log.refined_version || '');
            setOtherIssuesFound(data.log.other_issues_found || '');
          } else {
            setCriteriaToModify('');
            setRefinedVersion('');
            setOtherIssuesFound('');
          }
        }

        setFetchCompleted(true);
      });
  }

  // 按钮点击处理 - 新增切换显示/隐藏功能
  const handleButtonClick = (type) => {
    // 如果点击的是当前激活的按钮，则隐藏数据
    if (activeButton === type) {
      setActiveButton('');
      setDisplayData('');
    } else {
      // 否则显示对应数据
      setActiveButton(type);
      switch (type) {
        case 'criteria':
          setDisplayData(criteriaToModify);
          break;
        case 'refined':
          setDisplayData(refinedVersion);
          break;
        case 'other':
          setDisplayData(otherIssuesFound);
          break;
        default:
          setDisplayData('');
      }
    }
  };

  // 更新解释类型
  const updateExplanationType = async (newType) => {
    if (!newType || newType === explanationType) return;

    setIsUpdatingType(true);
    try {
      const obj = {
        id: questionId,
        explanationType: newType
      };
      await postData("questionApi/updateQuestionExplanationType", obj, navigate);
      setExplanationType(newType);
    } catch (error) {
      console.error("Failed to update explanation type:", error);
    } finally {
      setIsUpdatingType(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (!fetchCompleted) {
    return (<MyComponentLoading />)
  }

  const updateScript = async (value) => {
    let obj = {
      lang: toggle, value, qId: questionId
    }
    await postData("questionApi/updateExplanationScript", obj, navigate);
  }

  const regenScriptAudio = async (itemId, questionId, lang, script) => {
    if (lang == 'en') {
      setIsLoadingEn(true);
    } else if (lang == 'zh') {
      setIsLoadingZh(true);
    } else if (lang == 'zh_simplified') {
      setIsLoadingZhSimplified(true);
    }
    let obj = {
      lang, itemId, qId: questionId, script
    }

    await createOrUpdateQtn();
    let res = await postData("questionApi/regenScriptAudio", obj, navigate);
    fetchData();

     if (lang == 'en') {
      setIsLoadingEn(false);
    } else if (lang == 'zh') {
      setIsLoadingZh(false);
    } else if (lang == 'zh_simplified') {
      setIsLoadingZhSimplified(false);
    }
  }

  const generateScriptAi = async () => {
    setIsLoading(true);
    let obj = {
      lang: toggle, itemId, qId: questionId
    }

    await createOrUpdateQtn();
    let res = await postData("questionApi/generateScriptAi", obj, navigate);
    if (res.data) {
      setScriptEn(res.data.script);
      setScriptZh(res.data.scriptZh);
      setScriptZhSimplified(res.data.scriptZhSimplified);
    }
    setIsLoading(false);
    fetchData();
  }

  /*
  const generateExplanationScriptAudio = async (value) => {
    let obj = {
      lang: toggle, value, qId: questionId
    }
    let res = await postData("questionApi/generateExplanationScriptAudio", obj, navigate);
    let data = res.data

    if (toggle == 'en') {
      setAudioEn(data);
    } else if (toggle == 'zh') {
      setAudioZh(data);
    } else if (toggle == 'zh_simplified') {
      setAudioZhSimplified(data);
    }
  }*/

  // 检查是否有任何按钮需要显示
  const hasVisibleButtons = 
    isDataAvailable(criteriaToModify) || 
    isDataAvailable(refinedVersion) || 
    isDataAvailable(otherIssuesFound);

  return (
    <div className={s.mainHolder}>
      <div className={s.title}>Detail Explanation</div>
      <div style={{ background: "white", padding: "5px" }}>
        <div className={s.topSection}>
          {/* 解释类型选择 */}
          <div className={s.explanationTypeContainer}>
            <label htmlFor="explanationType" className={s.typeLabel}>Explanation Type:</label>
            <select
              id="explanationType"
              value={explanationType}
              onChange={(e) => updateExplanationType(e.target.value)}
              disabled={isUpdatingType}
              className={s.typeSelect}
              required
            >
              <option value="" disabled>Select type</option>
              {explanationTypes.map(type => (
                <option key={type.value} value={type.value}>
                  {type.display}
                </option>
              ))}
            </select>
          </div>
          
          {/* 语言切换和AI生成按钮 */}
          <div className={s.languageAndAiContainer}>
            <li className={s.toggleOptionHolder}>
              <ul className={(toggle == 'en') ? s.toggleOptionOn : ""} onClick={() => { setToggle('en'); }}>EN</ul>
              <ul className={(toggle == 'zh') ? s.toggleOptionOn : ""} onClick={() => { setToggle('zh'); }}>ZH</ul>
              <ul className={(toggle == 'zh_simplified') ? s.toggleOptionOn : ""} onClick={() => { setToggle('zh_simplified'); }}>ZH-Simplified</ul>
            </li>
            <GreenButton isEnabled={!isLoading} clickedAction={() => { generateScriptAi() }} bText={"Generate AI"} />
          </div>

          {/* 条件显示的按钮行 - 只有当有内容时才显示 */}
          {hasVisibleButtons && (
            <div className={s.newButtonRow}>
              {isDataAvailable(criteriaToModify) && (
                <BlueButton
                  isEnabled={true}
                  clickedAction={() => handleButtonClick('criteria')}
                  bText="Criteria"
                  // 添加激活状态样式
                  className={activeButton === 'criteria' ? s.activeButton : ''}
                />
              )}
              
              {isDataAvailable(refinedVersion) && (
                <BlueButton
                  isEnabled={true}
                  clickedAction={() => handleButtonClick('refined')}
                  bText="Refined"
                  className={activeButton === 'refined' ? s.activeButton : ''}
                />
              )}
              
              {isDataAvailable(otherIssuesFound) && (
                <BlueButton
                  isEnabled={true}
                  clickedAction={() => handleButtonClick('other')}
                  bText="Other"
                  className={activeButton === 'other' ? s.activeButton : ''}
                />
              )}
            </div>
          )}

          {/* 数据显示区域 - 只有当按钮被点击时显示 */}
          {activeButton && (
            <div className={s.displayContainer}>
              <p>{displayData}</p>
            </div>
          )}
        </div>
      </div>

      {/* 脚本输入区域 */}
      {
        (targetToggle == 'Script') &&
        (<>
          {toggle == 'en' && (<>
            <InputTextArea isLoading={isLoading} value={scriptEn} setValue={setScriptEn} updateValue={updateScript} />
            <textarea value={srtEn} readOnly/>
          </>)}
          {toggle == 'zh' && (<>
            <InputTextArea isLoading={isLoading} value={scriptZh} setValue={setScriptZh} updateValue={updateScript} />
            <textarea value={srtZh} readOnly/>
          </>)}
          {toggle == 'zh_simplified' && (<>
            <InputTextArea isLoading={isLoading} value={scriptZhSimplified} setValue={setScriptZhSimplified} updateValue={updateScript} />
            <textarea value={srtZhSimplified} readOnly/>
          </>)}
        </>)
      }
      
      {/* 音频播放器区域 */}
      <div>
        <AudioPlayer isLoading={isLoadingEn} regenScriptAudio={regenScriptAudio} itemId={itemId} questionId={questionId} lang="en" script={scriptEn} audio={audioEn} />
        <AudioPlayer isLoading={isLoadingZh} regenScriptAudio={regenScriptAudio} itemId={itemId} questionId={questionId} lang="zh" script={scriptZh} audio={audioZh} />
        <AudioPlayer isLoading={isLoadingZhSimplified} regenScriptAudio={regenScriptAudio} itemId={itemId} questionId={questionId} lang="zh_simplified" script={scriptZhSimplified} audio={audioZhSimplified} />
      </div>
    </div>
  );
}
    